import { useMutation } from '@tanstack/react-query';

import { marketplaceApi } from '../api/marketplaceApi';

export interface MarketplaceUploadImageItem {
  formFieldPath: string;
  uploadKey: string;
  label: string;
  file: File;
  arrayItemUid?: string;
}

interface UploadMarketplaceImagesPayload {
  marketplaceId: number;
  images: MarketplaceUploadImageItem[];
}

interface UploadMarketplaceImagesResult {
  failedUploads: {
    item: MarketplaceUploadImageItem;
    error: unknown;
  }[];
}

export function useMarketplaceImageUpload() {
  const { mutateAsync: uploadMarketplaceImages, isPending: isUploading } =
    useMutation({
      mutationFn: async (
        payload: UploadMarketplaceImagesPayload
      ): Promise<UploadMarketplaceImagesResult> => {
        const failedUploads: UploadMarketplaceImagesResult['failedUploads'] =
          [];

        for (const image of payload.images) {
          try {
            await marketplaceApi.uploadProductImage(
              payload.marketplaceId,
              image.uploadKey,
              image.file
            );
          } catch (error) {
            failedUploads.push({ item: image, error });
          }
        }

        return { failedUploads };
      },
    });

  return {
    uploadMarketplaceImages,
    isUploading,
  };
}
